import { Injectable } from '@angular/core';

@Injectable()
export class MessageService {
    messages: string[] = [];

    add(message: string) {
        this.messages.push(message);
    }

    clear() {
        this.messages = [];
    }
}


// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/service/message.service.ts